import { formatDate } from '@data-access';

import { FieldAnswerBulkItem } from '../../../lib/types/validation';

import { ValidationFieldValues } from './validation-form';

export function toBulkPayload(
  fields: ValidationFieldValues[],
  mapField: (field: ValidationFieldValues) => Omit<FieldAnswerBulkItem, 'id'>,
): FieldAnswerBulkItem[] {
  return fields.map((field) => ({
    id: field.key,
    ...mapField(field),
  }));
}

export function toSkipAllOrganicPayload(
  fields: ValidationFieldValues[],
): FieldAnswerBulkItem[] {
  return toBulkPayload(fields, () => ({
    organic: false,
    last_organic: null,
    is_validated: true,
  }));
}

export function toPerFieldBulkPayload(
  fields: ValidationFieldValues[],
): FieldAnswerBulkItem[] {
  return toBulkPayload(fields, (field) => ({
    organic: field.organic === 'oui',
    last_organic: field.last_organic
      ? formatDate({
          date: field.last_organic,
          format: 'db',
        })
      : null,
    is_validated: field.is_validated,
  }));
}
